/*
 * Copyright (C) 2012 Minted Inc.
 *
 * All Rights Reserved
 */

M.Model = M.Model || {};
M.Model.Sample = M.Model.Sample || {};

/**
 * @class M.Model.Sample.ColorChoice
 *
 * Models a user color choice, either from the pre-defined list of colors
 * or from a user described color
 *
 */
M.Model.Sample.ColorChoice = Backbone.Model.extend({
  defaults: {
    rgb: '',
    colorName: '',
    colorDescription: '',
    howToUseColor: '',
    additionalInstructions: '',
    isCustomColor: false
  }
});
